import { createIcon } from '../createIcon.tsx';

export const ChartBarIcon = createIcon(
	'ChartBarIcon',
	<>
		<rect x="3" y="3" width="18" height="18" rx="2" />
		<path d="M7 16V12" />
		<path d="M12 16V8" />
		<path d="M17 16V10" />
	</>,
);
